import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { DocumentFileTemplateTypeEnum } from '@zaoblako/shared/modules/catalog/enums/document-file-template-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link DocumentFileTemplateTypeEnum} enumeration values */
export const DocumentFileTemplateTypeEnumI18n: EnumI18nInterface<DocumentFileTemplateTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [DocumentFileTemplateTypeEnum.DEAL]: 'Сделка',
  },
  [I18nLocalesEnum.EN_US]: {
    [DocumentFileTemplateTypeEnum.DEAL]: 'Deal',
  },
};
